import * as React from 'react'

//Basic component to display Admin link in the menu
export const Admin: React.FunctionComponent = (props) => {

    return (
        <div>
            Administration
        </div>
    )
}